import React from 'react';
import { CheckCircleIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

const AccountCompletionStep = ({ userAlreadyExists }) => {
    const navigate = useNavigate();

    return (
        <div className="text-center py-12">
            <CheckCircleIcon className="h-16 w-16 text-emerald-400 mx-auto mb-6" />
            
            <h3 className="text-2xl font-semibold text-white mb-4">
                {userAlreadyExists ? 'Account Setup Complete!' : 'Account Created Successfully!'}
            </h3>
            
            <div className="backdrop-blur-sm bg-emerald-900/20 border border-emerald-800/30 rounded-xl p-6 mb-8">
                <div className="space-y-4">
                    <p className="text-emerald-400 font-medium">
                        {userAlreadyExists 
                            ? 'Your account setup has been completed successfully.'
                            : 'Your account has been created and is ready to use!'
                        }
                    </p>
                    
                    <div className="text-gray-300 text-sm space-y-2">
                        <p>✓ Account details saved</p>
                        <p>✓ Terms and conditions accepted</p>
                        <p>✓ No subscription required for this venue</p>
                    </div>
                </div>
            </div>

            <div className="backdrop-blur-sm bg-gray-900/20 border border-gray-700/30 rounded-xl p-6">
                <h4 className="text-lg font-semibold text-white mb-3">What's Next?</h4>
                <div className="text-gray-300 text-sm space-y-2 text-left">
                    <p>• You'll receive an account activation email shortly</p>
                    <p>• Click the activation link to verify your email address</p>
                    <p>• Once activated, you can start using all venue features</p>
                </div>
            </div>

            <div className="mt-8">
                <button
                    onClick={() => navigate('/login')}
                    className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-emerald-600 hover:bg-emerald-500 text-white font-semibold rounded-xl transition-colors"
                >
                    Complete
                    <ArrowRightIcon className="h-5 w-5" />
                </button>
            </div>
        </div>
    );
};

export default AccountCompletionStep;
